import { z } from 'zod/v4';

export const CUSTOM_VARIABLE_DISPLAY_TYPE = ['percentage', 'money', 'money_in_cents'] as const;

export type CustomVariableDisplayType = (typeof CUSTOM_VARIABLE_DISPLAY_TYPE)[number];

export const CustomVariableDisplayTypeSchema = z.enum([...CUSTOM_VARIABLE_DISPLAY_TYPE]);
